import { BaseEntity } from "./BaseEntity";

export class ServiceTypesEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "Tipo de serviço";
        this.pageTitle = "Tipo de serviço";
        this.menuPath = "";
        this.APIRoute = "Resources/Totem"
        this.i18nBase = "";
        this.baseEndPoint = "serviceTypes";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
        };

        this.fields = [
            {
                key: "id",
                label: "user.fields.id",
                type: "text",
                visible: false,
                editable: false,
                orderBy: false,
                path: "id"
            },
            {
                key: "name",
                label: "common.labels.name",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "external_identity",
                label: "Código de integração",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "external_identity"
            },
            {
                key: "description",
                label: "common.labels.description",
                type: "textarea",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "description"
            },
            {
                key: "icon",
                label: "Ícone",
                type: "selectIcon",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "icon"
            },
            {
                key: "status",
                label: null,
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path: "status"
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.tableColumns = [
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            edit: {
                pageTitle: `Editar Tipo de Atendimento`,
                pathI18n: `/Tipo de atendimentos`,
                route: ["/","/service-types", "/service-types/edit/:id"]
            },
            create: {
                pageTitle: `Criar Tipo de Atendimento`,
                pathI18n: `/Tipo de atendimentos`,
                route: ["/","/service-types", "/service-types/create"]
            },
            list: {
                pageTitle: `Tipo de atendimentos`,
                pathI18n: `/`,
                route: ["/", "/service-types"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path:"status"
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
